import React, { useState } from 'react';
import styled from 'styled-components';
import { ITab } from '../../types/ITab';

// Custom tab container
const TabsContainer = styled.div`
  // justify-content: center;
  align-items: start;
  display: flex;
  flex-direction: row;
  font-size: 20px;
  color: var(--Warm-Grey-warm-grey-500, #a2a4a1);
  font-weight: 700;
  white-space: nowrap;
  line-height: 120%;
  gap: 32px;
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.tabBorderColor};
  // background: ${({ theme }) => theme.playerHeaderBackground};
  // backdrop-filter: blur(32px);
  // padding-left: 60px;
  // padding-top: 30px;
`;

// Tab item
const TabItem = styled.div`
  align-items: start;
  display: flex;
  gap: 20px;
  justify-content: space-between;
  padding-bottom: 8px;
  cursor: pointer;
`;

// Tab title
const TabTitle = styled.div<{ active: boolean }>`
  color: ${({ active,theme }) => (active ? theme.playerColor : theme.tabTitleColor)};
  font-feature-settings: 'clig' off, 'liga' off;
  /* Aeonik/Title/Medium */
  font-family: 'Aeonik';
  font-size: 20px;
  font-style: normal;
  font-weight: ${({ active }) => (active ? 800 : 700)};
  line-height: 24px; /* 120% */
  position: relative;
  &:after {
    content: '';
    position: absolute;
    bottom: -8px; /* Adjust this value to align with the bottom border of TabsContainer */
    left: 0;
    width: 100%;
    height: ${({ active }) => (active ? '4px' : '0')};
    background-color: ${({ active }) => (active ? 'var(--Brand-green-1-500, #00D1A8)' : 'none')}; /* Color of the bottom border */
  }
`;

const SelectedTabContent = styled.div`
  background-color: #f0f0f0;
  padding: 10px;
  border-radius: 5px;
`;


interface CustomTabsProps {
  tabs: ITab[];
  activeTabKey: string;
  onTabClick: (key: string) => void;
}

// CustomTabs component
const CustomTabs: React.FC<CustomTabsProps> = ({ tabs, activeTabKey, onTabClick }) => {
  return (
    <TabsContainer>
      {tabs.map((tab, index) => (
        <TabItem key={index} onClick={() => onTabClick(tab.key)}>
          <TabTitle active={activeTabKey === tab.key}>{tab.title}</TabTitle>
          {/* {activeTab === index && (
            <SelectedTabContent>
              Selected Tab Content
            </SelectedTabContent>
          )} */}
        </TabItem>
      ))}
    </TabsContainer>
  );
};

export default CustomTabs;